import type { LocaleNamesMap } from "@dealer-center/core-interfaces-locale";

const locales: LocaleNamesMap = {
  "en-US": {
    ACCOUNT_SEARCH_FORM_HEADING: "Please enter a valid Account Id",
    ACCOUNT_SEARCH_INPUT_LABEL: "Search by account ID",
    ACCOUNT_SEARCH_SUBMIT_BTN_TEXT: "Go",
    WELCOME_HEADING: "Welcome",
    MORE_ACCOUNT: "more account",
    MORE_ACCOUNTS: "more accounts",
    RECENTLY_ACCESSED: "Recently Accessed",
    ACCOUNTS: "Accounts",
    ACCOUNT_SWITCHER_HEADER: "Switch Account or User",
    ACCOUNT_ONLY_SWITCHER_HEADER: "Switch Account",
    BACK: "Back",
    CLOSE: "Close",
    "core.500_ERROR":
      "The server encountered an unexpected condition which prevented it from fulfilling the request.",
    "core.ERROR_HEADING": "We're sorry, something went wrong.",
    NO_ACCOUNTS_FOUND: "No matching accounts found",
    LOADING_ACCOUNT_INFORMATION: "Loading Account Information",
    PLEASE_REFRESH: "Please refresh the page and try again.",
    SWITCH_ACCOUNT: "Switch accounts...",
    USERS: "Users",
    VIEWABLE_ACCOUNTS: "Viewable Accounts",
    VIEWABLE_USERS: "Viewable Users",
    SEARCH: "Search"
  },
  "es-US": {
    ACCOUNT_SEARCH_FORM_HEADING: "Por favor, introduzca un ID de cuenta válido",
    ACCOUNT_SEARCH_INPUT_LABEL: "Ingresar ID de cuenta",
    ACCOUNT_SEARCH_SUBMIT_BTN_TEXT: "Vamos",
    WELCOME_HEADING: "Bienvenidos",
    MORE_ACCOUNT: "más cuenta",
    MORE_ACCOUNTS: "más cuentas",
    RECENTLY_ACCESSED: "Accedido recientemente"
  },
  "en-CA": {
    ACCOUNT_SEARCH_FORM_HEADING: "Please enter a valid Account Id",
    ACCOUNT_SEARCH_INPUT_LABEL: "Search by account ID",
    ACCOUNT_SEARCH_SUBMIT_BTN_TEXT: "Go",
    WELCOME_HEADING: "Welcome",
    MORE_ACCOUNT: "more account",
    MORE_ACCOUNTS: "more accounts",
    RECENTLY_ACCESSED: "Recently Accessed",

    ACCOUNTS: "Accounts",
    ACCOUNT_SWITCHER_HEADER: "Switch Account or User",
    ACCOUNT_ONLY_SWITCHER_HEADER: "Switch Account",
    BACK: "Back",
    CLOSE: "Close",
    "core.500_ERROR":
      "The server encountered an unexpected condition which prevented it from fulfilling the request.",
    "core.ERROR_HEADING": "We're sorry, something went wrong.",
    LOADING_ACCOUNT_INFORMATION: "Loading Account Information",
    PLEASE_REFRESH: "Please refresh the page and try again",
    SWITCH_ACCOUNT: "Switch accounts...",
    USERS: "Users",
    VIEWABLE_ACCOUNTS: "Viewable Accounts",
    VIEWABLE_USERS: "Viewable Users",
    SEARCH: "Search"
  },
  "fr-CA": {
    ACCOUNT_SEARCH_FORM_HEADING:
      "Veuillez saisir un identifiant de compte valide",
    ACCOUNT_SEARCH_INPUT_LABEL: "Entrez l'ID de compte",
    ACCOUNT_SEARCH_SUBMIT_BTN_TEXT: "Aller",
    WELCOME_HEADING: "Bienvenue",
    MORE_ACCOUNT: "plus de compte",
    MORE_ACCOUNTS: "plus de comptes",
    RECENTLY_ACCESSED: "Accédé récemment",
    ACCOUNTS: "Comptes",
    ACCOUNT_SWITCHER_HEADER: "Gestion des comptes et d&rsquo;utilisateurs",
    ACCOUNT_ONLY_SWITCHER_HEADER: "Gestion des comptes",
    BACK: "Retour",
    CLOSE: "Fermer",
    "core.500_ERROR":
      "Le serveur a rencontré une erreur inattendue l'ayant empêché de satisfaire la demande.",
    "core.ERROR_HEADING": "Toutes nos excuses, une erreur s'est produite.",
    LOADING_ACCOUNT_INFORMATION:
      "Renseignements sur le compte en cours de chargement",
    PLEASE_REFRESH: "Veuillez actualiser la page et réessayer.",
    SWITCH_ACCOUNT: "Changer de compte",
    USERS: "Utilisateurs",
    VIEWABLE_ACCOUNTS: "Comptes affichables",
    VIEWABLE_USERS: "Utilisateurs visibles",
    SEARCH: "Rechercher"
  }
};

export { locales };
